import type { FC } from "react";
import React from "react";

import "./styles.scss";

type Props = {
    number: number;
    text: string;
    topic: string | null;
};

export const ExerciseBody: FC<Props> = ({ number, text, topic }: Props) => (
    <>
        {topic && <p className="exercise-body__topic">{topic}</p>}
        <div className="exercise-body__text">
            <div className="exercise-body__number">{number}.</div>
            <div dangerouslySetInnerHTML={{ __html: text }} />
        </div>
    </>
);
